﻿function debounce(func, wait) {
    let timeoutId;

    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), wait);
    };
}


function stringToInt(value) {
    if (!value || value == '') {
        return null;
    }
    return parseInt(motivUi.string.removeGroupSeparators(value))
}

function stringToFloat(value) {
    if (!value || value == '') {
        return null;
    }
    return parseFloat(motivUi.string.removeGroupSeparators(value))
}

function floatToCurrencyString(value, prefix = "£") {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    value = value.toFixed(2);
    const decimals = value.toString().split('.')[1] || null;
    const groupSeparatedValue = motivUi.string.addGroupSeparator(value);
    const integerPart = groupSeparatedValue.split('.')[0];

    let stringVal = integerPart.split('.')[0];
    if (groupSeparatedValue.split('.').length > 1 && decimals) {
        stringVal += `.${decimals}`;
    }

    return prefix + stringVal;
} 


async function divContentToClipboard(div) {
    const content = div?.innerText?.trim();

    if (!content) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(content);
        return true;
    } catch {
        return false;
    }
}

async function copyTextWithConfirmation(icon) {
    const container = icon.parentElement;

    const copied = await divContentToClipboard(container);
    if (!copied || container.querySelector(".copy-feedback")) {
        return;
    }

    icon.classList.remove("fa-copy");
    icon.classList.add("fa-check");

    const feedback = document.createElement("span");
    feedback.className = "copy-feedback";
    feedback.textContent = "Copied!";
    container.appendChild(feedback);

    setTimeout(() => {
        feedback.remove();

        icon.classList.remove("fa-check");
        icon.classList.add("fa-copy");
    }, 1500);
}

export { debounce, stringToInt, stringToFloat, floatToCurrencyString, divContentToClipboard, copyTextWithConfirmation }